import { createSelector } from '@reduxjs/toolkit';
import type { ApplicationState } from './types';

const selectAuthState = (state: ApplicationState) => state.auth;
export const selectToken = createSelector(selectAuthState, (state) => state.token);
export const selectName = createSelector(selectAuthState, (state) => state.name);

const selectMessageState = (state: ApplicationState) => state.message;
export const selectMessages = createSelector(selectMessageState, (state) => state.messages);
export const selectFirstMessage = createSelector(selectMessageState, (state) => state.messages[0]);
